import React, { useEffect, useState } from "react";
import GlobalWrapper from "../../../../../components/Wrapper/GlobalWrapper";
import { Box, Button, Chip, Paper, Typography } from "@mui/material";
import GlobalDatagrid from "../../../../../components/mui/DataGrid/GlobalDatagrid";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { getTrainerData } from "../../../../../redux/features/CRDslice";
import { useLocation, useNavigate } from "react-router-dom";
import { TrainerDataTableHead } from "../../../../../components/datagrid/CRD/NewAdmissionRegister/TrainerDataTableHead";

const CroTrainerMappingLanding = () => {
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { gridSize, pageNum, rowData, openAnchor, search } = paginationData;
  const { loading, trainerData } = useSelector((store) => store.crd);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const decoded = atob(queryParams.get("data") || "");
  const actualParams = new URLSearchParams(decoded);
  const crm = actualParams.get("crm") == "true" ? true : false;
  const courseEnrollmentIdFromQuery = actualParams.get("courseEnrollmentId");
  const leadDetailsRaw = actualParams.get("leadDetails");
  const [leadDetails, setLeadDetails] = useState(null);

  const dispatchParams = {
    paginationData,
    courseEnrollmentIdFromQuery,
  };

  useEffect(() => {
    let parsedLeadDetails = null;
    try {
      if (leadDetailsRaw) {
        parsedLeadDetails = JSON.parse(leadDetailsRaw);
      }
      setLeadDetails(parsedLeadDetails);
    } catch (error) {
      console.error("Error decoding or parsing URL data:", error);
    }
  }, [location.search]);

  useEffect(() => {
    if (pageNum && gridSize) {
      dispatch(getTrainerData(dispatchParams));
    }
  }, [gridSize, pageNum, search, courseEnrollmentIdFromQuery]);

  return (
    <GlobalWrapper title={"Tutor Mapping"}>
      <Box>
        <Box
          display="flex"
          flexWrap={"wrap"}
          justifyContent="space-between"
          p={2}
          sx={{
            gap: 1,
            px: 3,
            backgroundColor: "#2f72b3c9",
            borderRadius: 10, // more rounded corners
            // boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)"
          }}
        >
          <Chip
            variant="outlined"
            label={`Student Name : ${leadDetails?.student_name}`}
            sx={{
              backgroundColor: "white",
              color: "#000000",
              fontWeight: 500,
              fontSize: "1rem",
            }}
          />
          <Chip
            variant="outlined"
            label={`Admission No : ${leadDetails?.admn_no}`}
            sx={{
              backgroundColor: "white",
              color: "#000000",
              fontWeight: 500,
              fontSize: "1rem",
            }}
          />
          <Chip
            variant="outlined"
            label={`Project : ${leadDetails?.project_name}`}
            sx={{
              backgroundColor: "white",
              color: "#000000",
              fontWeight: 500,
              fontSize: "1rem",
            }}
          />

          <Chip
            variant="outlined"
            label={`Course Name : ${leadDetails?.course_name}`}
            sx={{
              backgroundColor: "white",
              color: "#000000",
              fontWeight: 500,
              fontSize: "1rem",
            }}
          />
        </Box>
      </Box>
      <Box mt={1}>
        <Paper elevation={3}>
          <GlobalDatagrid
            tableHead={TrainerDataTableHead({
              navigate,
              dispatchParams,
              crm: crm,
            })}
            rows={trainerData.data}
            meta={trainerData.meta?.totalRecords}
            rowUniqueId="sl_no"
            loading={loading}
            rowClick={false}
          />
        </Paper>
      </Box>
    </GlobalWrapper>
  );
};

export default CroTrainerMappingLanding;
